import { baseClient } from '../_api';

export const requestEmailConfirmation = emailOrPhone =>
  baseClient.post('/request_email_confirmation/', { emailOrPhone });
